import React, { Component } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { injectIntl, defineMessages } from 'react-intl';
import { show as showModal } from 'redux-modal';
import MediaQuery from 'react-responsive';

import LinkedInModal, { MODAL_NAME as IMPORT_LINKEDIN_MODAL_NAME } from './modal';
import Button from 'ui/common/button';
import routeTemplates from 'ui/common/routes/templates';
import themeConfig from 'ui/theme/config';

const button = defineMessages({
  label: {
    id: 'user.import.linked-in.title',
    defaultMessage: 'Import LinkedIn Data',
  },
});

class LinkedInImportButton extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  showLinkedInModal() {
    this.props.showModal(IMPORT_LINKEDIN_MODAL_NAME);
  }

  render() {
    const { className, intl: { formatMessage }, isReady } = this.props;

    return (
      <div className={className}>
        <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.md}>
          <Button
            to={routeTemplates.imports.linkedInCsv}
            isReady={isReady}
            className="btn btn-social btn-linkedin"
          >
            {formatMessage(button.label)}
          </Button>
        </MediaQuery>
        <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.md - 1}>
          <Button
            onClick={this.showLinkedInModal}
            isReady={isReady}
            className="btn btn-social btn-linkedin"
          >
            {formatMessage(button.label)}
          </Button>
        </MediaQuery>
        <LinkedInModal />
      </div>
    );
  }
}

const mapDispatchToProps = {
  showModal,
};

export default connect(null, mapDispatchToProps)(injectIntl(LinkedInImportButton));
